import type { DrawerContextType } from "./types";

export const INITIAL_DRAWER_CONTEXT: DrawerContextType = {
  direction: "right",
};
